import { z } from 'zod';

export const searchSchema = z.object({
  ngay_tu: z.string().optional(),
  ngay_den: z.string().optional(),
  duoc_thanh_toan_de: z.string().optional(),
  ngay_tat_toan: z.string().optional(),
  tai_khoan_no: z.string().optional(),
  tat_toan: z.string().optional().default('1'),
  mau_bao_cao: z.string().optional().default('1'),
  so_ct_tu: z.string().optional(),
  so_ct_den: z.string().optional(),
  mau_loc_bao_cao: z.string().optional().default('0'),
  unit_id: z.string().optional(),
  status: z.string().optional()
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export const initialValues: SearchFormValues = {
  ngay_tu: '',
  ngay_den: '',
  duoc_thanh_toan_de: '',
  ngay_tat_toan: '',
  tai_khoan_no: '',
  tat_toan: '1',
  mau_bao_cao: '1',
  so_ct_tu: '',
  so_ct_den: '',
  mau_loc_bao_cao: '0',
  unit_id: '',
  status: ''
};
